import React from 'react'
import { Link } from 'react-router-dom'
import MainBanner from '../Banner/MainBanner'

type Props = {
    className: string
}

export const Header: React.FC<Props> = ({ className }) => {
    return (
        <div
            className={'w-full h-fit items-center justify-center ' + className}
        >
            <div className="flex flex-row w-[1200px] h-[700px] bg-[#181818] p-2 px-10 m-3 rounded-3xl gap-2 ">
                <div className="flex flex-col w-[500px] h-full items-center justify-center text-[#FFFFFF] gap-14 text-[16px] ">
                    <div className="flex flex-col w-full h-fit items-center justify-center text-[#FFFFFF] gap-5 text-[16px] ">
                        <div className="w-full text-left text-[40px] font-semibold uppercase leading-[42px] ">
                            АВТОМАТИЗАЦИЯ ЗАКУПОК 223-ФЗ <br />
                            <span className="text-[#407bff]">
                                НОВОГО УРОВНЯ
                            </span>
                        </div>
                        <div className="w-full text-left ">
                            NOXSYS – современная система автоматизации закупок
                            для организаций-заказчиков, работающих по
                            Федеральному закону “О закупках товаров, работ,
                            услуг отдельными видами юридических лиц" от
                            18.07.2011 N 223-ФЗ
                        </div>
                        {/* <div className="w-full text-left ">
                      Разработана с учетом реальных потребностей
                      специалистов и требований законодательства.
                  </div> */}
                    </div>
                    <div className="flex w-full text-left ">
                        <Link to={'/price'}>
                            <div className="flex min-w-[120px] h-8 px-2 text-[12.8px] items-center justify-center rounded-[10px] border-2 border-[#407bff] hover:bg-[#407bff] hover:border-[#407bff] hover:text-[#FFFFFF] duration-300 transform transition-all">
                                Стать клиентом
                            </div>
                        </Link>
                    </div>
                </div>
                <div className="w-[700px] h-full text-[#FFFFFF] z-10">
                    <MainBanner />
                </div>
            </div>
        </div>
    )
}
